import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=c5ad9016&"
import script from "./BubbleChart.vue?vue&type=script&setup=true&lang=js&"
export * from "./BubbleChart.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports